module.exports = __webpack_public_path__ + "ye.svg?bb77153d9e8a0da06709361df86235d7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ye.svg
// module id = 1227
// module chunks = 27